import { LAYERS, Z_INDEX_LAYER_SIZE } from "../helpers/consts";
import { Placement } from "./Placement";
import { SFX } from "../classes/Sounds";

export class PickupPlacement extends Placement {
  getEditingLayer() {
    return LAYERS.PICKUPS;
  }

  playSfxOnCollect() {
    return SFX.COLLECT;
  }

  getZIndex() {
    return this.y * Z_INDEX_LAYER_SIZE;
  }
}
